<script lang="ts" setup>
import { useForwardPropsEmits } from 'radix-vue';
import { DrawerContent, DrawerPortal } from 'vaul-vue';

import DrawerOverlay from '@/components/lib/shadcn-vue/drawer/DrawerOverlay.vue';
import { cn } from '@/components/lib/shadcn-vue/utils';

import type { DialogContentEmits, DialogContentProps } from 'radix-vue';
import type { HtmlHTMLAttributes } from 'vue';

interface ExtendedProps extends DialogContentProps {
  class?: HtmlHTMLAttributes['class'];
  position?: 'bottom' | 'right';
  /** SP で画面いっぱいに開く。位置の指定は cn() の最後に来るため、呼び出し側の class では上書きできない */
  fullHeight?: boolean;
}

const props = withDefaults(defineProps<ExtendedProps>(), {
  position: 'bottom',
  class: '',
  fullHeight: false,
});
const emits = defineEmits<DialogContentEmits>();
const forwarded = useForwardPropsEmits(props, emits);
const positionClasses = computed(() => {
  if (props.position === 'right') return 'inset-y-0 mt-0 top-0 right-0 h-full w-[600px]';
  return props.fullHeight ? 'inset-x-0 inset-y-0 mt-0 h-full' : 'inset-x-0 bottom-0 h-auto mt-24';
});
</script>

<template>
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerContent v-bind="forwarded" :class="cn('bg-background fixed z-[201] flex flex-col', props.class, positionClasses)">
      <!-- 画面いっぱいのときはドラッグして閉じる余白が無いので、つまみも出さない -->
      <div v-if="props.position !== 'right' && !props.fullHeight" class="bg-muted mx-auto mt-2 h-2 w-[100px] rounded-full" />
      <slot />
    </DrawerContent>
  </DrawerPortal>
</template>

<style>
/*
 * ドロワー内のテキストを選択・コピー可能にする
 * vaul-drawerはデフォルトでテキスト選択が無効のため上書き
 * PC等マウス操作デバイスのみ適用（タッチデバイスはドラッグ操作を優先）
 */
@media (hover: hover) and (pointer: fine) {
  [data-vaul-drawer] {
    -webkit-user-select: text !important;
    user-select: text !important;
  }
}
</style>
